import { React, useState, useEffect } from "react";
import request from "../../../../Helpers/API";
import { Modal, TextField } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import RemoveCircleIcon from "@mui/icons-material/DeleteForever";
import AddCircleIcon from "@mui/icons-material/AddCircle"

export const ListadoPreciosModal = ({ open, onClose, id_paquete, paquete }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [nuevoItem, setNuevoItem] = useState({
        modelo: "",
        precio: "",
    });

    const [items, setItems] = useState([]);

    const handleAgregar = () => {
        if (!nuevoItem.modelo || !nuevoItem.precio) {
            Swal.fire("Atención", "Debes capturar modelo y precio", "warning");
            return;
        }

        setItems([...items, { ...nuevoItem, id_paquete }]);
        setNuevoItem({ modelo: "", precio: "" });
    };

    // actualizar un precio en línea dentro de la tabla
    const handleEditPrecio = (index, value) => {
        const copia = [...items];
        copia[index].precio = value;
        setItems(copia);
    };

    const [listado, setListado] = useState({
        modelo: "",
        id_paquete,
        precio: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNuevoItem((prev) => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        if (open && id_paquete) {
            setLoader((prev) => ({ ...prev, mostrar: true }));

            request
                .get(`DashboardPostventa/GetPreciosMantenimiento?id_paquete=${id_paquete}`)
                .then((result) => {
                    setLoader((prev) => ({ ...prev, mostrar: false }));
                    setItems(result || []);
                })
                .catch((error) => {
                    setLoader((prev) => ({ ...prev, mostrar: false }));
                    console.error(error);
                    Swal.fire("Error", "No se pudo cargar los precios", "error");
                });
        } else {
            setItems([]);
        }
    }, [open, id_paquete]);


    const onGuardar = () => {
        if (items.length === 0) {
            Swal.fire("Atención", "Debes capturar al menos un precio", "warning");
            return;
        }

        setLoader({ ...loader, mostrar: true });
        const post = { precios_Mantenimiento: items };
        request
            .post(`DashboardPostventa/AgregarPreciosMantenimiento`, post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                await Swal.fire({
                    title: "PAQUETE DE MANTENIMIENTO",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PAQUETE DE MANTENIMIENTO", JSON.stringify(error), "error");
            });
        onClose();
    };

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="paquetes-mantenimiento-modal-formulario">
                    <div className="paquetes-mantenimiento-modal-plantilla">
                        <div
                            className="plantilla-screen-filtro-container"
                            id="mdlFiltros-modal"
                        >
                            <PlantillaScreen
                                titulo={
                                    "LISTADO DE PRECIOS DEL PAQUETE " + (paquete?.toUpperCase() ?? "")
                                }
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>
                                    X
                                </div>

                                <div className="paquetes-mantenimiento-modal">
                                    <div className="paquetes-mantenimiento-listado-precios-modal">
                                        <TextField
                                            label="Modelo"
                                            name="modelo"
                                            value={nuevoItem.modelo}
                                            onChange={handleChange}
                                            fullWidth
                                        />
                                        <TextField
                                            label="Precio"
                                            name="precio"
                                            value={nuevoItem.precio}
                                            onChange={handleChange}
                                            type="number"
                                            fullWidth
                                        />
                                        <button
                                            className="paquetes-mantenimiento-modal-button-añadir"
                                            onClick={handleAgregar}
                                        >
                                            <AddCircleIcon style={{ color: "white", fontSize: "28px" }} />
                                        </button>
                                    </div>
                                    <div className="paquetes-mantenimiento-modal-container">
                                        <div className="paquetes-mantenimiento-modal-container-table">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            Modelo
                                                        </th>
                                                        <th>
                                                            <div>Precio</div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {items.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="celda-modelo">
                                                                <div className="celda-modelo-container">
                                                                    {item.modelo}
                                                                </div>
                                                            </td>
                                                            <td className="celda-importe">
                                                                <input
                                                                    type="number"
                                                                    value={item.precio}
                                                                    onChange={(e) =>
                                                                        handleEditPrecio(index, e.target.value)
                                                                    }
                                                                    style={{
                                                                        width: "100px",
                                                                        padding: "4px",
                                                                        backgroundColor: 'transparent',
                                                                        border: "none",
                                                                        textAlign: "right",
                                                                        MozAppearance: "textfield",
                                                                        appearance: "textfield",
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>


                                    <div className="paquetes-mantenimiento-modal-buttons">
                                        <button
                                            className="paquetes-mantenimiento-modal-button-guardar"
                                            onClick={onGuardar}
                                        >
                                            Guardar todo
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
